import { useEffect } from "react";
import RecentlyListedTable from "../../components/ebayListings/recentlyListed/RecentlyListedTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import useCategories from "../../data/useCategories";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import RecentlyListedStats from "../../components/ebayListings/recentlyListed/RecentlyListedStats";


export default function RecentlyListed() {
  const { categories } = useCategories();
  const { setInfo } = usePageNameContext();


  useEffect(() => {
    setInfo({
      name: "eBay Recently Listed Items",
      desc: "View parts that were listed in the last 90 days",
    });
  }, []);

  if (categories.isLoading) return <LoadingWheel />;

  return (
    <div className="flex flex-col gap-y-4 mt-4">
      <RecentlyListedStats />
      <RecentlyListedTable categories={categories.data?.data} />
    </div>
  )
}